import React from 'react'
import { useHasLeaseCompanySetUp } from 'app/hooks/use-has-lease-company-set-up'
import { useHasPermission } from 'utils/Subscription/RequiredPermissions'
import { CheckIfLeaseCompanyIsSetUp } from './CheckIfLeaseCompanyIsSetUp'
import { PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE } from 'utils/Subscription/Permissions'
import { RetryableErrorAlert } from '@carsys/ui'
import { Box } from '@mui/material'

export function IsFleetLeaseSetUp({ children }: React.PropsWithChildren<{}>) {
  const [isFleetLeaseWhiteLabelEnabled] = useHasPermission(PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE)
  const isLeaseCompanySetUp = useHasLeaseCompanySetUp()

  if (isLeaseCompanySetUp.isLoading && !isLeaseCompanySetUp.isFetching) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  if (isLeaseCompanySetUp.isFetching || isLeaseCompanySetUp.isLoading) {
    return null
  }

  if (isLeaseCompanySetUp.isError) {
    return (
      <Box sx={{ width: 600 }}>
        <RetryableErrorAlert onRetry={isLeaseCompanySetUp.refetch} />
      </Box>
    )
  }

  return (
    <CheckIfLeaseCompanyIsSetUp
      isFleetLeaseWhiteLabelEnabled={isFleetLeaseWhiteLabelEnabled}
      isLeaseCompanySetUp={isLeaseCompanySetUp.data}
    >
      {children}
    </CheckIfLeaseCompanyIsSetUp>
  )
}
